import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=08ecab41&scoped=true&"
import script from "./Candidates.vue?vue&type=script&lang=js&"
export * from "./Candidates.vue?vue&type=script&lang=js&"
import style0 from "./Candidates.vue?vue&type=style&index=0&id=08ecab41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ecab41",
  null
  
)

export default component.exports